export default "__VITE_ASSET__Bsn5SWot__"